import React, { useEffect, useRef } from "react";

/** 随内容自动增高的多行输入（最小 2 行，最多约 12 行后滚动） */
export const AutoGrowTextarea = ({ value, onChange, className = "", minRows = 2, maxPx = 288, ...props }) => {
  const ref = useRef(null);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    el.style.height = "auto";
    el.style.height = `${Math.min(el.scrollHeight, maxPx)}px`;
    el.style.overflowY = el.scrollHeight > maxPx ? "auto" : "hidden";
  }, [value, maxPx]);
  return (
    <textarea ref={ref} rows={minRows} value={value || ""} onChange={onChange}
      className={`flex w-full rounded-md border border-slate-200 bg-white px-3 py-2 text-sm leading-relaxed placeholder:text-slate-400 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-slate-400 resize-none ${className}`}
      {...props} />
  );
};
